import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { AlertTriangle } from 'lucide-react';

export default function SensitiveSectionConfirmDialog({ open, title, message, onCancel, onConfirm }) {
  return (
    <Dialog
      open={Boolean(open)}
      onClose={onCancel}
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: 8
        }
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.25, fontWeight: 'bold' }}>
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: '50%',
            bgcolor: '#fee2e2',
            color: '#b91c1c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <AlertTriangle size={18} />
        </Box>
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onCancel}>
          Annulla
        </Button>
        <Button variant="contained" onClick={onConfirm} sx={{ borderRadius: '12px' }}>
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
}

